import { useCallback, useEffect, useState } from "react";

import { MUIIcon } from "./MUIIcon";
import { Spinner } from "./Spinner";
import moment from "moment";
import { useInterval } from "react-use";

export const CountdownTimer = ({ endTime, label }: { endTime: Date, label: string }) => {
    const { duration: remainingTime } = useCalcRemainingTime({ endTime });
    const formatTimeComponent = (value: number) => (value < 10 ? `0${value}` : value);

    return (
        <div className="align-self-center ">
            <div className="border bg-body px-5 py-3 rounded-2 shadow-sm">
                <div className="d-flex gap-1 align-items-center justify-content-center">
                    <Spinner />
                    <label className="fs-7 fw-bold">{label}</label>
                </div>
                <hr />
                <div className="d-flex gap-3 justify-content-center align-items-center">
                    <MUIIcon iconName="AccessTimeOutlined" className="fs-3x text-primary" />
                    <div>
                        <div className="row fw-bold fs-7">
                            <div className="col-4">HH</div>
                            <div className="col-4">MM</div>
                            <div className="col-4">SS</div>
                        </div>
                        <div className="row fw-bolder">
                            <div className="col-4">{formatTimeComponent(remainingTime.hours)}</div>
                            <div className="col-4">{formatTimeComponent(remainingTime.minutes)}</div>
                            <div className="col-4">{formatTimeComponent(remainingTime.seconds)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

interface ITimeDuration {
    hours: number,
    minutes: number,
    seconds: number
}

interface IRemainingTimeState {
    isFuture?: boolean,
    duration: ITimeDuration
}

export const useCalcRemainingTime = ({ endTime }: { endTime?: Date | string }) => {
    const [state, setState] = useState<IRemainingTimeState>({
        duration: { hours: 0, minutes: 0, seconds: 0 }
    });

    const calculateTimeRemaining = useCallback(() => {
        const specificDate = moment(endTime);
        const currentDate = moment();
        const difference = moment.duration(specificDate.diff(currentDate));
        const isFuture = specificDate.isAfter(currentDate)

        if (!isFuture)
            return setState({ isFuture, duration: { hours: 0, minutes: 0, seconds: 0 } });

        const seconds = difference.seconds();
        const minutes = difference.minutes();
        const hours = difference.hours()

        setState({ isFuture, duration: { hours, minutes, seconds } });
    }, [endTime]);

    useInterval(() => {
        calculateTimeRemaining();
    }, 1000)

    useEffect(() => {
        calculateTimeRemaining();
        // eslint-disable-next-line
    }, [endTime]);

    return state
}

